let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

/* ------------------------------------------------------------------
 * Avuno: SoleGlide free gift lock
 * - The Refill Kit (free gift) quantity always equals the number of
 *   SoleGlide units in the cart.
 * - Customers cannot change or remove the gift line themselves.
 * ------------------------------------------------------------------ */
(function () {
  var MAIN_PRODUCT_ID = 10291324715231;
  var GIFT_PRODUCT_ID = 10295110303967;
  var GIFT_HANDLE_PART = 'refill-kit-60-discs';
  var syncing = false;

  function injectCss() {
    if (document.getElementById('avuno-gift-lock-css')) return;
    var s = document.createElement('style');
    s.id = 'avuno-gift-lock-css';
    s.textContent =
      '.cart-item[data-avuno-gift] quantity-popover,' +
      '.cart-item[data-avuno-gift] quantity-input,' +
      '.cart-item[data-avuno-gift] cart-remove-button{display:none!important}' +
      '.avuno-gift-qty{margin:0;font-size:1.3rem;opacity:.75}';
    document.head.appendChild(s);
  }

  function markRows() {
    document.querySelectorAll('.cart-item').forEach(function (row) {
      var a = row.querySelector('a[href*="/products/"]');
      if (!a) return;
      var href = '';
      try { href = decodeURIComponent(a.getAttribute('href') || ''); } catch (e) { href = a.getAttribute('href') || ''; }
      if (href.indexOf(GIFT_HANDLE_PART) === -1) return;
      if (!row.hasAttribute('data-avuno-gift')) row.setAttribute('data-avuno-gift', '');
      var input = row.querySelector('input.quantity__input');
      var q = input ? input.getAttribute('value') || input.value : '';
      var text = 'Qty ' + q + ' · Free gift';
      var label = row.querySelector('.avuno-gift-qty');
      if (!label) {
        var anchor = row.querySelector('quantity-popover') || row.querySelector('quantity-input');
        label = document.createElement('p');
        label.className = 'avuno-gift-qty';
        label.textContent = text;
        if (anchor && anchor.parentNode) {
          anchor.parentNode.insertBefore(label, anchor);
        } else {
          row.appendChild(label);
        }
      } else if (label.textContent !== text) {
        label.textContent = text;
      }
    });
  }

  function refreshCartUi() {
    var drawerItems = document.querySelector('cart-drawer-items');
    if (drawerItems && typeof drawerItems.onCartUpdate === 'function') drawerItems.onCartUpdate();
    var pageItems = document.querySelector('cart-items');
    if (pageItems && typeof pageItems.onCartUpdate === 'function') pageItems.onCartUpdate();
  }

  function syncGift() {
    if (syncing) return Promise.resolve();
    syncing = true;
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var mainQty = 0;
        var giftQty = 0;
        var giftKeys = [];
        cart.items.forEach(function (it) {
          if (it.product_id === MAIN_PRODUCT_ID) mainQty += it.quantity;
          if (it.product_id === GIFT_PRODUCT_ID) { giftQty += it.quantity; giftKeys.push(it.key); }
        });
        if (giftKeys.length === 0) return;
        if (giftQty === mainQty && giftKeys.length === 1) return;
        var updates = {};
        giftKeys.forEach(function (k, i) { updates[k] = i === 0 ? mainQty : 0; });
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () { refreshCartUi(); });
      })
      .catch(function (e) { console.error('Avuno gift sync', e); })
      .finally(function () { syncing = false; });
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function () { syncGift(); });

  var markTimer = null;
  function queueMark() {
    if (markTimer) return;
    markTimer = setTimeout(function () { markTimer = null; markRows(); }, 30);
  }

  function init() {
    injectCss();
    markRows();
    new MutationObserver(queueMark).observe(document.body, { childList: true, subtree: true });
    syncGift();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
